module.exports = __webpack_public_path__ + "static/media/oil.30bcc22d.jpg";